import { apiClient } from './api';
import { Member, PaginatedResponse } from '../types';

interface BackendPaginatedResponse<T> {
  data: T[];
  total: number;
  page: number;
  pages: number;
}

class MemberService {
  async getAllMembers(filters?: {
    membershipType?: string;
    membershipStatus?: string;
    search?: string;
    page?: number;
    limit?: number;
  }): Promise<PaginatedResponse<Member>> {
    const response = await apiClient.get<BackendPaginatedResponse<Member>>('/admin/members', filters);
    // Convert backend format to frontend format
    return {
      items: response.data,
      total: response.total,
      page: response.page,
      limit: filters?.limit || 10,
      totalPages: response.pages
    };
  }

  async getMemberById(id: string): Promise<Member> {
    return apiClient.get<Member>(`/admin/members/${id}`);
  }

  async updateMember(id: string, data: Partial<Member>): Promise<Member> {
    return apiClient.patch<Member>(`/admin/members/${id}`, data);
  }

  async deleteMember(id: string): Promise<void> {
    return apiClient.delete(`/admin/members/${id}`);
  }

  async getMemberProfile(): Promise<Member> {
    return apiClient.get<Member>('/member/profile');
  }

  async updateMemberProfile(data: Partial<Member>): Promise<Member> {
    return apiClient.put<Member>('/member/profile', data);
  }
}

export const memberService = new MemberService();
